module.exports = __webpack_public_path__ + "img/footer_company_02.cef4e78b.png";